import React from 'react';
import { Col, FormGroup } from 'reactstrap';
import { Field } from 'redux-form';
import TranslatableWysiwygField from '../../../../TranslatableWysiwygField/TranslatableWysiwygField';

const RichTextSettings = ({ env, screen, widget }) => {
    return (
        <FormGroup row className="widget-setting">
            <Col sm={ 12 }>
                <Field
                    name={ `mobile.${env}.screens.${screen}.widgets[${widget.index}].text` }
                    component={ TranslatableWysiwygField }
                />
            </Col>
        </FormGroup>
    );
}

export default RichTextSettings;
